<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-11 00:10:37
 * @LastEditTime: 2025-05-18 21:14:41
-->
<template>
  <div class="myCollect">
    <!-- <div class="title">
        <van-button type="info" block>精准匹配</van-button>
      </div> -->

    <listPost type="myCollect"></listPost>
    <van-tabbar v-model="active">
      <van-tabbar-item icon="home-o" @click="toUrl('/tool')"
        >首页</van-tabbar-item
      >
      <van-tabbar-item icon="orders-o" @click="toUrl('/enterpriseList')">企业名录</van-tabbar-item>
      <van-tabbar-item icon="apps-o" @click="toUrl('/intelligencePost')"
        >标准筛岗</van-tabbar-item
      >
      <van-tabbar-item icon="bookmark-o" @click="toUrl('/precisePost')"
        >智能筛岗</van-tabbar-item
      >
    
      <!-- <van-tabbar-item icon="setting-o" @click="toUrl(="/home">重点标识</van-tabbar-item> -->
      <van-tabbar-item icon="manager-o">我的收藏</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem } from 'vant'

Vue.use(Tabbar)
Vue.use(TabbarItem)
import { Button } from 'vant'
Vue.use(Button)
import listPost from './post/component/listPost.vue'
export default {
  name: 'myCollect',
  data () {
    return {
      active: 4
    }
  },
  created () {},
  components: {
    listPost
  },
  watch: {},
  methods: {
    toUrl (path) {
      if (!path) {
        Toast('功能开发中')
        return
      }

      this.$router.replace({ path })
    }
  }
}
</script>
<style scoped lang="scss">
.title {
  padding: 20px 10px;
}
</style>
